import NewsCard from "../../components/Tips/NewsCard";

const tipsData = [
	{
		title: "Comprendre sa facture pour mieux agir",
		description:
			"Découvrez comment décrypter ses principales composantes (abonnement, consommation, taxes) pour reprendre le contrôle sur votre consommation et mieux agir au quotidien.",
		url: "https://symphonics.fr/comprendre-sa-facture-pour-mieux-agir/",
	},
	{
		title: "Identifier la consommation de vos usages ",
		description:
			"Où part votre électricité ? Chauffage, eau chaude, électroménager…  Identifier les postes les plus gourmands est la première étape pour mieux consommer et faire des économies. Nos conseils pour reprendre la main.",
		url: "https://symphonics.fr/agir-sur-sa-consommation/",
	},
	{
		title: "Déporter sa consommation vers les heures creuses",
		description:
			"En décalant vos usages vers les heures creuses, vous réduisez vos factures et votre impact carbone. On vous explique comment tirer parti de cette astuce simple et efficace pour faire des économies… sans rien sacrifier à votre confort !",
		url: "https://symphonics.fr/deporter-sa-consommation-hc-hp/",
	},
	{
		title: "Maîtriser le chauffage électrique, premier poste de consommation",
		description:
			"Le chauffage pèse lourd sur votre facture, mais il est aussi l’un des leviers les plus simples à optimiser. Température adaptée, entretien,pose d'un thermostat, isolation ou programmation : découvrez nos conseils pour gagner en confort tout en allégeant vos dépenses ",
		url: "https://symphonics.fr/maitriser-le-chauffage-electrique-premier-poste-de-consommation/",
	},
	{
		title: "Adopter un usage raisonné des appareils numériques",
		description:
			"Smartphones, ordinateurs, box... Nos appareils connectés consomment plus qu’on ne le pense. Adoptez les bons réflexes pour prolonger leur durée de vie et alléger leur empreinte énergétique ",
		url: "https://symphonics.fr/adopter-un-usage-raisonne-des-appareils-numeriques/",
	},
	{
		title: "Gérer intelligemment les appareils en veille",
		description:
			"Même éteints, certains appareils continuent de consommer. Quelques gestes simples suffisent pour limiter ces pertes invisibles et faire des économies sur la durée",
		url: "https://symphonics.fr/gerer-intelligemment-les-appareils-en-veille/",
	},
	{
		title: "Rafraîchir son logement sans climatisation",
		description:
			"Face aux vagues de chaleurs, des gestes simples permettent de préserver la fraîcheur de son intérieur tout en maîtrisant sa consommation d'énergie. Voici nos astuces pour un été au frais sans pris de tête. ",
		url: "https://symphonics.fr/rafraichir-son-logement-sans-climatisation/",
	},
	{
		title: "Produire sa propre électricité grâce aux énergies renouvelables",
		description:
			"Et si vous passiez à l'autoconsommation ? Produire et consommer sa propre électricité, c'est possible, rentable et plus simple qu'il n'y paraît ! ",
		url: "https://symphonics.fr/produire-sa-propre-electricite-grace-aux-energies-renouvelables/",
	},
	{
		title: "Faire des travaux de rénovation",
		description:
			"Réduire vos factures, améliorer votre confort, valoriser votre logement...La rénovation énergétique coche toutes les cases ! Voici pourquoi (et comment) franchir ce cap",
		url: "https://symphonics.fr/faire-des-travaux-de-renovation/",
	},
	{
		title: "Privilégier les ampoules basse consommation",
		description:
			"Et si un simple changement d’ampoules pouvait alléger vos factures ? Les ampoules LED consomment jusqu’à 80 % d’énergie en moins et durent des années. Performantes, durables et connectées elles sont un choix malin pour votre éclairage...et pour la planète ",
		url: "https://symphonics.fr/privilegier-les-ampoules-basse-consommation/",
	},
];

const Tips = () => {
	return (
		<div className="container mx-auto px-4 py-8 mb-20 mt-10">
			<div className="mb-8">
				<h1 className="text-2xl md:text-3xl font-bold text-gray-800">
					Nos conseils et astuces
				</h1>
			</div>
			<div className="grid gap-6 grid-cols-1  lg:grid-cols-3">
				{tipsData.map((tip, index) => (
					<NewsCard
						key={`${tip.title}-${index}`}
						title={tip.title}
						description={tip.description}
						url={tip.url}
					/>
				))}
			</div>
		</div>
	);
};

export default Tips;
